const TransactionSource = Object.freeze({
  Stripe: 'stripe',
  SplitIt: 'splitIt',
  Spreedly: 'spreedly',
  Pax: 'pax',
  PayFabric: 'payfabric',
  GlobalPay: 'globalpay',
  Rectangle: 'rectangle',
});

export default TransactionSource;
